var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleJoinedVoiceCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F9F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0892 9.91058C25.7637 9.58514 25.2361 9.58514 24.9107 9.91058L22.1666 12.6547V11.3332C22.1666 10.8729 21.7935 10.4998 21.3333 10.4998C20.873 10.4998 20.4999 10.8729 20.4999 11.3332V14.6665C20.4999 15.1267 20.873 15.4998 21.3333 15.4998H24.6666C25.1268 15.4998 25.4999 15.1267 25.4999 14.6665C25.4999 14.2063 25.1268 13.8332 24.6666 13.8332H23.3451L26.0892 11.0891C26.4146 10.7637 26.4146 10.236 26.0892 9.91058Z",
    fill: "#1E2131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4313 10.4998C10.7422 10.4998 10.0814 10.7736 9.5942 11.2608C9.10697 11.748 8.83325 12.4088 8.83325 13.0979C8.83325 13.1147 8.83376 13.1316 8.83479 13.1484C9.05629 16.7934 10.6041 20.2313 13.1863 22.8135C15.7684 25.3956 19.2063 26.9435 22.8513 27.165C22.8682 27.166 22.885 27.1665 22.9019 27.1665C23.5909 27.1665 24.2517 26.8928 24.739 26.4056C25.2262 25.9183 25.4999 25.2575 25.4999 24.5685V22.1674C25.4999 21.1452 24.8775 20.2259 23.9284 19.8462L21.7118 18.9596C20.6707 18.5432 19.4813 18.9439 18.9044 19.9054C18.7212 20.2107 18.4113 20.2318 18.2447 20.1188C17.3142 19.4878 16.5119 18.6856 15.881 17.7551C15.768 17.5885 15.7891 17.2786 16.0944 17.0954C17.0559 16.5185 17.4566 15.329 17.0401 14.2879L16.1535 12.0714C15.7738 11.1222 14.8546 10.4998 13.8323 10.4998H11.4313Z",
    fill: "#1E2131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleJoinedVoiceCall);
export default __webpack_public_path__ + "static/media/people-joined-voice-call.47324823b04f7b83fcff411bf67a1307.svg";
export { ForwardRef as ReactComponent };